module.exports = __webpack_public_path__ + "img/home_head_sm.f32c6679.png";